/**
 * The sentence the server sent, or a fallback when it sent none.
 *
 * Every API refusal carries `message` in the one error shape the server
 * emits (`server/src/utils/serviceError.js` for a transition, the validation
 * middleware for a bad body). That sentence names what actually happened,
 * which a generic retry line cannot: a 409 on accept means the requester
 * withdrew first, and telling the member to try again is wrong advice.
 *
 * The fallback covers the cases with no response at all, a dropped
 * connection or a 5xx with no body.
 */
export function serverMessage(error, fallback) {
    return error?.response?.data?.message || fallback;
}

export default serverMessage;
